export default __webpack_public_path__ + "static/0188-851861bc6a007370305b6c17c075ab20.png";